import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    label: _ctx.label,
    "model-value": _ctx.modelValue,
    options: _ctx.filteredOptions,
    outlined: "",
    dense: "",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => _ctx.$emit('update:modelValue', value)),
    "emit-value": "",
    "map-options": "",
    clearable: "",
    "use-input": "",
    onFilter: _ctx.filterFn
  }, null, 8, ["label", "model-value", "options", "onFilter"]))
}